// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rectdraw-container {
	width: fit-content;
	height: fit-content;
	place-self: center;
	position: relative;

	.rectdraw {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}

	.rectdraw.enabled {
		border: 1px solid #000000;
		cursor: crosshair;
	}

	.rectangle {
		fill: rgba(255, 255, 255, 0);
		stroke-width: 3;
		stroke: rgb(250, 0, 0);
	}

	.label {
		fill: rgb(250, 0, 0);
	}

	.rectangle.edit {
		stroke-dasharray: 5, 5;
	}

	.rectangle.highlight {
		stroke: lightgray;
		stroke-width: 8;
	}

	.label.highlight {
		fill: lightgray;
		stroke: lightgray;
		stroke-width: 3;
	}

	.rectangle.ai-observation {
		stroke: rgb(0, 0, 250);
	}

	.label.ai-observation {
		fill: rgb(0, 0, 250);
	}

	.rectangle.uncertain {
		stroke: orange;
	}

	.label.uncertain {
		fill: orange;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/drawstyles.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;;CAElB;EACC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,yBAAyB;EACzB,iBAAiB;CAClB;;CAEA;EACC,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,iBAAiB;EACjB,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,YAAY;CACb;AACD","sourcesContent":[".rectdraw-container {\n\twidth: fit-content;\n\theight: fit-content;\n\tplace-self: center;\n\tposition: relative;\n\n\t.rectdraw {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n\n\t.rectdraw.enabled {\n\t\tborder: 1px solid #000000;\n\t\tcursor: crosshair;\n\t}\n\n\t.rectangle {\n\t\tfill: rgba(255, 255, 255, 0);\n\t\tstroke-width: 3;\n\t\tstroke: rgb(250, 0, 0);\n\t}\n\n\t.label {\n\t\tfill: rgb(250, 0, 0);\n\t}\n\n\t.rectangle.edit {\n\t\tstroke-dasharray: 5, 5;\n\t}\n\n\t.rectangle.highlight {\n\t\tstroke: lightgray;\n\t\tstroke-width: 8;\n\t}\n\n\t.label.highlight {\n\t\tfill: lightgray;\n\t\tstroke: lightgray;\n\t\tstroke-width: 3;\n\t}\n\n\t.rectangle.ai-observation {\n\t\tstroke: rgb(0, 0, 250);\n\t}\n\n\t.label.ai-observation {\n\t\tfill: rgb(0, 0, 250);\n\t}\n\n\t.rectangle.uncertain {\n\t\tstroke: orange;\n\t}\n\n\t.label.uncertain {\n\t\tfill: orange;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
